export default class SearchHelper {
  constructor(el) {
    this.el = el;
    this.formSelector = this.el.getAttribute('data-form-selector');
    this.qsForm = document.getElementById(this.formSelector);
    this.genderField = this.qsForm.querySelector('select[name="Geschlecht"]');
    this.userGender = this.qsForm.querySelector('select[name="Partner"]');
    this.genderOptionF = this.genderField.querySelector('option[value="f"]');
    this.genderOptionM = this.genderField.querySelector('option[value="m"]');
    this.genderOptionE = this.genderField.querySelector('option[value="e"]');
    this.init();
  }

  /* eslint-disable class-methods-use-this */
  init() {
    this.el.addEventListener('change', () => {
      if (this.el.value === 'Partnerschaft') {
        this.genderOptionE.removeAttribute('selected');
        if (this.userGender.value === 'm') {
          this.genderOptionF.setAttribute('selected', 'selected');
          this.genderField.value = 'f';
        } else {
          this.genderOptionM.setAttribute('selected', 'selected');
          this.genderField.value = 'm';
        }
        this.genderOptionE.setAttribute('disabled', 'disabled');
      } else {
        this.genderOptionE.removeAttribute('disabled');
      }
    });
  }
  /* eslint-enable class-methods-use-this */
}



// WEBPACK FOOTER //
// ./src/main/javascripts/modules/search_helper.js